import React from "react";
import { QrCode, Download, Printer } from "lucide-react";

const items = [
  { key: "master",      label: "Master (all shops)",  url: "/book", subtitle: "Book any of our 4 Sydney ateliers" },
  { key: "rhodes",      label: "Rhodes",              url: "/book?shop=rhodes",      subtitle: "Rhodes shop" },
  { key: "ashfield",    label: "Ashfield",            url: "/book?shop=ashfield",    subtitle: "Ashfield shop" },
  { key: "west-ryde",   label: "West Ryde",           url: "/book?shop=west-ryde",   subtitle: "West Ryde shop" },
  { key: "charlestown", label: "Charlestown",         url: "/book?shop=charlestown", subtitle: "Charlestown shop" },
  { key: "track",       label: "Track Order",         url: "/track",                 subtitle: "Give to picked-up clients" },
];

function printPoster(src) {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`
    <html><head><title>Hedieh's QR Poster</title>
    <style>
      body { margin: 0; }
      img { display: block; width: 100%; max-width: 800px; margin: 0 auto; }
      @page { size: A4 portrait; margin: 0; }
      @media print { body { -webkit-print-color-adjust: exact; } }
    </style></head><body>
    <img src="${src}" onload="window.focus();window.print();"/></body></html>`);
  w.document.close();
}

export default function AdminQR() {
  return (
    <div className="p-8 md:p-12 max-w-5xl">
      <div className="overline">Admin · Marketing</div>
      <h1 className="font-serif-display text-4xl mt-2 flex items-center gap-3">
        <QrCode size={32}/> QR Posters
      </h1>
      <p className="text-[#4A4A4A] mt-3 text-sm max-w-2xl">
        Print these on A4 and put one at each shop counter. Customers scan with their phone camera →
        lands directly on the booking page. There's also a master QR you can share on Instagram, WhatsApp, or Facebook.
      </p>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(({ key, label, url, subtitle }) => {
          const poster = `/qr/${key}-poster.png`;
          const plain = `/qr/${key}-plain.png`;
          const fullUrl = `https://fitting-hub-5.emergent.host${url}`;
          return (
            <div key={key} className="border border-[#E2E8F0] bg-white overflow-hidden">
              <div className="aspect-[3/4] bg-[#F8FAFC] overflow-hidden">
                <img src={poster} alt={label} className="w-full h-full object-contain"/>
              </div>
              <div className="p-5">
                <div className="font-serif-display text-xl">{label}</div>
                <div className="text-xs text-[#4A4A4A] mt-1 truncate">{fullUrl}</div>
                <div className="text-xs text-[#4A4A4A] mt-0.5">{subtitle}</div>
                <div className="mt-4 flex flex-wrap gap-2">
                  <a href={poster} download={`hediehs-${key}-poster.png`}
                     data-testid={`qr-download-poster-${key}`}
                     className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest px-3 py-2 bg-[#0F172A] text-[#FFFFFF] hover:bg-[#B8941F]">
                    <Download size={12}/> Poster
                  </a>
                  <a href={plain} download={`hediehs-${key}-qr.png`}
                     data-testid={`qr-download-plain-${key}`}
                     className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest px-3 py-2 border border-[#0F172A] hover:bg-[#0F172A] hover:text-[#FFFFFF]">
                    <Download size={12}/> QR only
                  </a>
                  <button onClick={() => printPoster(poster)}
                          data-testid={`qr-print-${key}`}
                          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest px-3 py-2 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0F172A]">
                    <Printer size={12}/> Print
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-12 border border-[#E2E8F0] bg-[#F8FAFC] p-6">
        <div className="overline">How to use</div>
        <ol className="mt-3 space-y-2 text-sm list-decimal list-inside text-[#0F172A]">
          <li>Tap <strong>Print</strong> on any card and print A4 portrait — one for each shop.</li>
          <li>Tape the poster to the counter, mirror, or door.</li>
          <li>Customers point their phone camera → phone shows "Book with Hedieh's" → they tap it → booking form opens.</li>
          <li>Tap <strong>QR only</strong> to download a clean square you can share on Instagram, WhatsApp status, or Facebook stories.</li>
        </ol>
      </div>
    </div>
  );
}
